<div class="d-flex mt-1">

  <div class="grid formgrid p-fluid">
    <!-- <div *ngIf="!isRespigimento"></div> -->
    <div class="field col-12">
      <label for="noteImpresa">Note <strong>IMPRESA</strong></label>
      <span class="p-input-icon-left">
        <i class="pi pi-info-circle"></i>
        <textarea id="noteImpresa" rows="3" [autoResize]="true" pInputTextarea [disabled]="true">{{noteImpresa}}</textarea>
      </span>
    </div>

    <div class="centra-bottoni mt-2">
      <button 
        pButton 
        pRipple 
        icon="pi pi-times" 
        (click)="dialogRef.close(true)" 
        label="CHIUDI" 
        class="p-button-outlined mt-1">
      </button>
    </div>
  </div>
</div>
